import React from 'react'
import awsLogo from './assets/aws-logo.png'
import bedrockLogo from './assets/bedrock-logo.png'
import screenshot1 from './assets/screens/scan.incident.png'
import screenshot2 from './assets/screens/incident.result.png'
import appleStoreButton from './assets/apple.store.button.png'
import googlePlayButton from './assets/google.play.button.png'
import appLogo from './assets/logo.white.tr.png'

export default function App() {
  const appStoreLink = 'https://apps.apple.com/us/app/respondr/id6756633576'
  return (
    <div className='flex flex-col text-center items-center justify-center'>
      <section className='flex flex-col items-center justify-center text-center p-6'>
        {/*logo*/}
        <div className='flex flex-col items-center justify-center mb-10 mt-5'>
          <a href='https://respondr.online'><img src={appLogo} alt='Respondr¹' className='h-20 mb-4' /></a>
        </div>

        {/*Screenshots*/}
        <div className='flex flex-col sm:flex-row gap-8 items-center'>
          <div className='hidden sm:relative sm:w-[250px] sm:h-[466px] sm:block'>
            <img
              src={screenshot1}
              alt='Respondr¹ app screenshot'
              className='absolute inset-0 w-full h-full object-cover'
            />
          </div>
          <div className='relative w-[250px] h-[466px]'>
            <img
              src={screenshot2}
              alt='Respondr¹ app screenshot 2'
              className='absolute inset-0 w-full h-full object-cover'
            />
          </div>
        </div>

        {/*Description*/}
        <p className='max-w-xl mt-14 mb-8 font-light text-xl text-white'>
          ¹Respondr: AI-assisted decision support for time-critical opioid overdose response
        </p>

        <div className='flex flex-row align-middle center'>
          <a href={appStoreLink} target='_blank' rel='noopener noreferrer'
             className='relative inline-flex items-center justify-center py-4 mb-10 text-lg font-light uppercase text-white transition-all duration-300 ease-out hover:scale-105'>
            <img src={appleStoreButton} alt='App Store' className='h-12 mr-4' />
          </a>

          {/*<a href={googlePlayLink} target='_blank' rel='noopener noreferrer'></a>*/}
          <div className='opacity-30 grayscale relative inline-flex items-center justify-center py-4 mb-10 text-lg font-light uppercase text-white transition-all duration-300 ease-out hover:scale-105'>
            <img src={googlePlayButton} alt='App Store' className='h-12 mr-4' />
          </div>
        </div>

      </section>

      <section className='max-w-4xl mx-auto text-center py-16 px-6 border-t border-white/30'>
        <h2 className='text-3xl font-light mb-6 uppercase'>What is Respondr¹?</h2>
        <p className='text-lg opacity-90 font-light leading-relaxed'>
          Respondr¹ provides a guided overdose assessment experience designed to support users during suspected overdose situations by helping them observe, document, and respond appropriately.
        </p>
      </section>

      <section className='max-w-4xl mx-auto text-center py-16 px-6 border-t border-white/30'>
        <h2 className='text-3xl font-light mb-6 uppercase'>
          What problem is Respondr¹ solving?
        </h2>

        <p className='text-lg opacity-90 leading-relaxed mt-8 mb-8'>
          The U.S. is facing a devastating opioid crisis - with over <strong>77,000</strong> overdose
          deaths last year and an estimated <strong>816,000</strong> people
          addicted to fentanyl, one of the deadliest opioids ever made.
        </p>

        <p className='text-lg opacity-90 leading-relaxed mt-8 mb-8'>
          Every day, someone collapses in public, and uncertainty keeps
          bystanders from acting. Those lost minutes can mean
          the difference between life and death.
        </p>

        <p className='text-lg opacity-90 leading-relaxed'>
          <strong>Respondr¹</strong> helps bystanders recognize overdose symptoms,
          capture key details, and share clear information with 911 so first-responders can act faster.
        </p>
      </section>

      <section className='max-w-4xl mx-auto text-center py-16 px-6 border-t border-white/30'>
        <h2 className='text-2xl font-light mb-4 uppercase'>Disclaimer</h2>
        <p className='opacity-90 text-lg font-light'>
          Respondr¹ uses <strong>artificial intelligence (AI).</strong>
          You are interacting with an automated software system, not a human.
          It does <strong>not replace professional medical judgment</strong>. The results may be inaccurate or incomplete.
          Always call emergency services (911) in a real-life emergency.
        </p>
      </section>

      <section className='max-w-4xl mx-auto text-center py-16 px-6 border-t border-white/30'>
        <h2 className='text-2xl font-light mb-4 uppercase'>Credits</h2>
        <p className='opacity-90 text-lg mb-4 font-light'>
          Created by <strong>Evalua Studio LLC</strong>.
        </p>
      </section>

      <section className='min-w-80 max-w-4xl mx-auto text-center py-16 px-6 border-t border-white/30'>
        <h2 className='text-2xl font-light mb-4 uppercase'>Powered by:</h2>
        <div className='flex justify-center items-center gap-10 mt-14'>
          <a href='https://aws.amazon.com' target='_blank'><img src={awsLogo} alt='AWS' className='h-10 opacity-90' /></a>
          <a href='https://aws.amazon.com/bedrock/' target='_blank'><img src={bedrockLogo} alt='Nova' className='h-10 opacity-90' /></a>
        </div>
      </section>

      <footer className='text-center text-xs py-8 opacity-70'>
        © {new Date().getFullYear()} Respondr¹ all rights reserved |&nbsp;
        <a href='/terms.html'>Terms & conditions</a>&nbsp;|&nbsp;
        <a href='/privacy.html'>Privacy statement</a>
      </footer>
    </div>
  )
}
